import { isNil, isEmpty } from "ramda";

// nil test needed because
// ramda considers null to be not empty
const isEmptyOrNil = (value) => isNil(value) || isEmpty(value);
export default isEmptyOrNil;
